import React from 'react';
import { InputSearch, type MultiSelectProps } from '@allygpo/ally-ux';

type FilterTemplate = NonNullable<MultiSelectProps['filterTemplate']>;
// PrimeReact passes these at runtime but leaves them out of MultiSelectTemplateOptions.
type FilterHandlers = {
  onFilter?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  filterInputKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
};

/**
 * `filterTemplate` for a filterable MultiSelect: Ally UX's InputSearch in place of
 * the default borderless filter input. PrimeReact keeps the filter value and does the filtering.
 */
export const multiSelectSearch = (placeholder = 'Search'): FilterTemplate => (options) => {
  const { onFilter, filterInputKeyDown } = options as typeof options & FilterHandlers;
  return (
    <InputSearch
      className="flex-1"
      leftIcon={<i className="pi pi-search" aria-hidden="true" />}
      value={options.props?.filterValue ?? ''}
      onChange={(event) => onFilter?.(event)}
      onKeyDown={filterInputKeyDown}
      // No clear button: inside the MultiSelect's overlay its click counts as outside and closes the list.
      showClearButton={false}
      placeholder={placeholder}
      aria-label={placeholder}
    />
  );
};
